import { styled } from 'office-ui-fabric-react';
import { getNavGroupStyles } from './NavGroup.styles';
import { NavGroupBase } from './NavGroupBase';
export var NavGroup = styled(NavGroupBase, getNavGroupStyles, undefined, { scope: 'NavGroup' });
//# sourceMappingURL=NavGroup.js.map